import ShopifyImage from '../../ui/ShopifyImage'
import Badge from '../../ui/Badge'

export default function ShopifyVariantHeader({
    variant,
    product,
    isSearchVariant,
}) {
    const v = variant

    const is_custom_code_valid =
        v.country_code_of_origin && v.harmonized_system_code

    const has_watch_clock_details =
        v.wcd_power && v.wcd_jewels && v.wcd_strap && v.wcd_case

    return (
        <div className="flex gap-5 items-center w-full">
            <div className="h-[80px] aspect-square border relative rounded-xl overflow-hidden">
                {(variant.image_url || product.image_url) && (
                    <ShopifyImage
                        fill
                        sizes="100px"
                        className="object-contain "
                        src={
                            variant.image_url
                                ? variant.image_url
                                : product.image_url
                        }
                    />
                )}
            </div>

            <div className="flex justify-between w-full items-start">
                <div className="flex flex-col">
                    <span className="font-medium text-lg">{v.title}</span>

                    {v.sku && (
                        <span className="text-gray-500 text-sm">{v.sku}</span>
                    )}

                    {!v.sku && (
                        <span className="text-red-500 text-sm">
                            SKU manquant
                        </span>
                    )}

                    <div className="mt-2 text-gray-500 text-sm">
                        {v.quantity_available} sur Shopify
                    </div>

                    <div className="text-sm text-gray-500">ID : {v.id}</div>

                    <div className="text-sm text-gray-500">
                        {v.inventory_policy === 'CONTINUE'
                            ? 'Continuer à vendre en cas de rupture'
                            : 'Ne pas vendre en cas de rupture'}
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    {!v.sku && <Badge color="red">SKU manquant</Badge>}

                    {v.sku && <Badge color="green">{v.sku}</Badge>}

                    {isSearchVariant && (
                        <Badge color="blue">Variante recherchée</Badge>
                    )}

                    {variant.deleted_at && (
                        <Badge color="red">Variante supprimée</Badge>
                    )}

                    {is_custom_code_valid && (
                        <Badge color="gray">
                            {v.country_code_of_origin} -{' '}
                            {v.harmonized_system_code}
                        </Badge>
                    )}

                    {!is_custom_code_valid && (
                        <Badge color="red">Sans code douanier</Badge>
                    )}

                    {v.weight ? (
                        <Badge color="gray">{v.weight} g</Badge>
                    ) : (
                        <Badge color="red">Sans poids</Badge>
                    )}

                    {has_watch_clock_details && (
                        <Badge color="green">WCD rempli</Badge>
                    )}

                    {!has_watch_clock_details && (
                        <Badge color="gray">Sans WCD</Badge>
                    )}
                </div>
            </div>
        </div>
    )
}
